export default __webpack_public_path__ + "static/media/assessment-star.22aee3a6.svg";